import { createAsyncAction } from 'typesafe-actions';
import { PortalPermission } from '../../types/Permission';

export const getPortalPermissions = createAsyncAction(
    'GET_PORTAL_PERMISSIONS',
    'GET_PORTAL_PERMISSIONS_SUCCESS',
    'GET_PORTAL_PERMISSIONS_FAILED',
)<undefined, PortalPermission, undefined>();
